<template>
    <div class="filter-entry">
        <div class="filter-label">
            {{ name }}
        </div>
        <div style="margin-left: 20px;">
            <el-checkbox v-model="checked" @change="change('checked')">{{ yes }}</el-checkbox>
            <el-checkbox v-model="unchecked" @change="change('unchecked')">{{ no }}</el-checkbox>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'name',
            'id',
            'data',
            'yesLabel',
            'noLabel'
        ],
        data() {
            return {
                checked: null,
                unchecked: null,
                yes: this.yesLabel || 'Enabled',
                no: this.noLabel || 'Disabled'
            };
        },
        methods: {
            change(field) {
                if (field == 'checked') {
                    this.unchecked = false;
                }
                if (field == 'unchecked') {
                    this.checked = false;
                }

                this.data[this.id] = (this.checked === false && this.unchecked === false) ? null : this.checked;
            }
        }
    }
</script>